var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"min-height":"600"}},[_c('v-card-title',[_c('span',{staticClass:"text-h5"},[_vm._v("Grafo distinta")])]),_c('v-card-text',[_c('network',{ref:"network",attrs:{"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }